import { render, staticRenderFns } from "./MainButton.vue?vue&type=template&id=c030cc46&scoped=true&"
import script from "./MainButton.vue?vue&type=script&lang=js&"
export * from "./MainButton.vue?vue&type=script&lang=js&"
import style0 from "./MainButton.vue?vue&type=style&index=0&id=c030cc46&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c030cc46",
  null
  
)

export default component.exports